/**
 * vue相关全局变量,可以在非vue组件的js中调用
 * @type {{}}
 */
const AppContext = {
  $app: null,
  $store: null,
  $router: null,
  init({ app, router, store }) {
    this.$app = app;
    this.$store = store;
    this.$router = router;
  },
};

export default AppContext;
